import Script from "next/script";

export const SellwildVideoAdsTag = () => {
  return <>
    <Script id="pbjsSetConfig" dangerouslySetInnerHTML={{ __html: `
        window.pbjs = window.pbjs || {};
        window.pbjs.que = window.pbjs.que || [];
        window.pbjs.que.push(function () {
          window.pbjs.setConfig({
            /* Or whatever your preferred video cache URL is */
            cache: {
              url: "https://prebid.adnxs.com/pbc/v1/cache",
            },
          });
        })
      ` }} />
      <Script
        async
        type="text/javascript"
        src="https://widget.sellwild.com/v1_1_114/video.js"
        id="sellwild-video"
      />
  </>
}

export const bidders = [
  // {
  //   bidder: "synacormedia",
  //   params: { seatId: "sellwild", placementId: "102147", video: { skippable: true } },
  // },
  {
    bidder: 'amx',
    params: { tagId: 'YW50ZW5nby5jb20tdmlkZW8', video: { skippable: true } }
  },
  {
    bidder: 'rubicon',
    params: { accountId: 23260, siteId: 367108, zoneId: 1996616, video: { skippable: true, size_id: 277, language: 'en' } } //Size IDs (277 - Outstream In Feed, 201 - Pre-Roll, 204 - Mid-Roll)
  },
  {
    bidder: 'pubmatic',
    params: { publisherId: '160587', adSlot: '5246248', video: { skippable: true } }
  },
  {
    bidder: 'appnexus',
    params: { placementId: 32347944, video: { skippable: true } }
  },
  {
    bidder: 'unruly',
    params: { siteId: '264351', video: { skippable: true } }
  },
  // {
  //   bidder: "imds",
  //   params: { seatId: "sellwild", placementId: "102147" },
  // },
]